import './api/salary-table-operations.js';
import './api/updateSalaryFromGPT.js';
import './entities/SalaryTable.js';
import './enum/SalaryTableLevels.js';
import './enum/SalaryTableRow.js';
import './enum/SalaryTableRowKeys.js';
import './server/getSalaryTable.js';
